import { graphql } from "api/cms-website/generated";

export const MultiColumnFragment = graphql(/* GraphQL */ `
    fragment MultiColumnFragment on ComponentComponentsMultiColumn {
        id
        noMarginBottom
        multiColumnTitle: title
        multiColumnSubtitle: subtitle
        multiColumnItems: items {
            ...ColumnFragment
        }
        multiColumnCta: cta {
            ...ButtonFragment
        }
        columnType
        mobileSlider
        narrowColumns
        gridSpacing
        gridRows
        mobileGridRows
        gridRowGap
    }
`);
